import React from "react";
import { Outlet } from "react-router-dom";
import Content from "../../Components/Core/Content";

const Payment = () => {
  return (
    <div>
      <Content>
          <Outlet />
      </Content>
    </div>
  );
};

export default Payment;
